/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import get from 'lodash/get';
import merge from 'lodash/merge';
import keyBy from 'lodash/keyBy';

import {
  ADD_KPI,
  ADD_KPI_FAILURE,
  ADD_KPI_SUCCESS,
  ADD_V2_KPIS,
  ADD_V2_KPIS_FAILURE,
  ADD_V2_KPIS_SUCCESS,
  REMOVE_KPI,
  REMOVE_KPI_FAILURE,
  REMOVE_KPI_SUCCESS,
  REMOVE_V2_KPIS,
  REMOVE_V2_KPIS_FAILURE,
  REMOVE_V2_KPIS_SUCCESS,
  UPDATE_COMPLEX_KPI,
  UPDATE_COMPLEX_KPI_FAILURE,
  UPDATE_COMPLEX_KPI_SUCCESS,
  GET_KPIS,
  GET_KPIS_FAILURE,
  GET_KPIS_SUCCESS,
  GET_V2_KPIS,
  GET_V2_KPIS_FAILURE,
  GET_V2_KPIS_SUCCESS,
  SELECT_KPI_LOG,
  CLEAR_KPI_LOG,
} from 'kpiActionCreators';

export const kpisReducer = (
  state = { data: {}, updatingData: false, fetchingData: false },
  action
) => {
  switch (action.type) {
    case ADD_KPI_SUCCESS:
    case REMOVE_KPI_SUCCESS:
    case ADD_V2_KPIS_SUCCESS:
    case REMOVE_V2_KPIS_SUCCESS:
      return {
        ...state,
        updatingData: false,
        fetchingData: false,
        fetchDataError: null,
        data: keyBy(action.payload, 'name'),
      };
    case UPDATE_COMPLEX_KPI:
    case ADD_KPI:
    case REMOVE_KPI:
    case ADD_V2_KPIS:
    case REMOVE_V2_KPIS:
      return {
        ...state,
        updatingData: action.type,
        updateDataError: null,
      };
    case ADD_KPI_FAILURE:
    case REMOVE_KPI_FAILURE:
    case ADD_V2_KPIS_FAILURE:
    case REMOVE_V2_KPIS_FAILURE:
    case UPDATE_COMPLEX_KPI_FAILURE:
      return {
        ...state,
        updatingData: false,
        updateDataError: action.payload,
      };

    case UPDATE_COMPLEX_KPI_SUCCESS:
      return merge(
        {},
        state,
        {
          updatingData: false,
          updateDataError: null,
        },
        {
          data: {
            [action.payload.name]: action.payload,
          },
        }
      );

    default:
      return state;
  }
};

export const hierarchyItemKPIsReducer = (
  state = { data: {}, updatingData: false, fetchingData: false },
  action
) => {
  switch (action.type) {
    case GET_KPIS_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: keyBy(action.payload, 'name'),
      };
    case GET_KPIS:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
      };
    case GET_KPIS_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    default:
      return state;
  }
};

export const kpiFunctionsReducer = (
  state = { data: {}, updatingData: false, fetchingData: false },
  action
) => {
  switch (action.type) {
    case GET_V2_KPIS_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: keyBy(action.payload, 'name'),
      };
    case GET_V2_KPIS:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
      };
    case GET_V2_KPIS_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    default:
      return state;
  }
};

export const kpiLogReducer = (state = {}, action) => {
  switch (action.type) {
    case SELECT_KPI_LOG:
      return {
        ...state,
        data: action.payload,
      };
    case CLEAR_KPI_LOG:
      return {
        ...state,
        data: undefined,
      };
    default:
      return state;
  }
};

export const getSelectedKPILog = state => get(state, 'selectedKPILog.data') || {};

export const getIsSendingKPIData = state => get(state, 'kpis.updatingData');

export const getKpiFunctions = state => get(state, 'kpiFunctions.data') || [];

export const getKpiFunctionsUpdateError = state => get(state, 'kpis.updateDataError');
